const deCamelCase = (key) => (
  key.replace(/\W+/g, '-').replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase()
);

const computeAttrs = (component) => (
  Object.keys(component)
  .map(key => {
    let dataAttr = `${deCamelCase(key)}=`;
    let attr = (typeof component[key] !== 'object')
      ? `"${component[key]}"`
      : `"${key}"`;
    if (Array.isArray(component[key])) {
      attr = encodeURIComponent(JSON.stringify(component[key]));
    }
    return dataAttr += attr;
  })
  .join(' ')
);

export default function ($compile, $templateCache) {
  "ngInject";
  return {
    restrict: 'E',
    scope: {
      cause: '='
    },
    link(scope, el, attrs) {
      const { cause } = scope;
      let components; 

      if (cause) {

        if (cause.subentity && cause.subentity.portal) {
          components = cause.subentity.portal.components;
        }
        else if (cause.templating && cause.templating.portal) {
          components = cause.templating.portal.components;
        }
        try {
          const container = angular.element('<div class="tmplt_wrapper"/>');
          const causeCopy = angular.copy(cause);
          delete causeCopy.$promise;
          angular.forEach(components, (component) => {
            component.id = cause.id;
            component.cause = causeCopy;
            const $scope = angular.merge(scope.$new(true), component);
            const attributes = computeAttrs(component);
            const cmpnt = $compile(`<${component.name} ${attributes}></${component.name}>`)($scope);
            container.append(cmpnt);
          });
          el.append(container);
        } catch (e) {
          console.log('oops', e);
        }
      }
    },
    template: '<div />'
  };
}



// WEBPACK FOOTER //
// ./js/containers/causePortal/directives/templateDelegater.js